import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { FieldElement } from "@/react/types/Element";

export const elementToBlock = (
  element: FieldElement,
  fieldIndex: number,
): BaseBlock => ({
  id: element.id.toString(),
  type: "FormDropdownBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: element.attributes.label,
    },
    required: {
      prop: "other",
      type: "boolean",
      value: element.attributes.required,
    },
    options: {
      prop: "other",
      type: "choice-options",
      value: (element.attributes.options || []).map((option, index) => ({
        id: `option-${index}`,
        value: option,
      })),
    },
  },
  meta: {
    elementType: "field",
    elementId: element.id,
    elementableId: element.elementable_id,
    position: element.position,
    parentElementId: element.parent_element_id,
    fieldIndex,
  },
});
